import { createContext } from "react";
const TestSeriesProvider = createContext();
export default TestSeriesProvider;

